import { z } from "zod/v4";
import { AgenticSettingsReviewOpType } from "../../types";

// SCHEMA ONLY. packages/app compiles this through the llm/schema barrel, so keep it free of
// database, storage, and other node-only imports.

const contextReviewUpdateBrandImageGuardrailsOperationSchema = z.object({
  op_type: z.literal(AgenticSettingsReviewOpType.UpdateBrandImageGuardrails),
  profile_id: z
    .string()
    .min(1)
    .describe(
      "Id of the live brand profile, from read_image_guardrails `brand_profiles`.",
    ),
  allow_image_generation: z
    .boolean()
    .describe(
      "False blocks AI image generation and editing in every ad for this brand, so ads use only approved assets as-is. True allows it, subject to each collection's guardrails. Must differ from the profile's current `allow_image_generation` in read_image_guardrails.",
    ),
});

export const BRAND_IMAGE_GUARDRAILS_WIRE_OPERATIONS = [
  contextReviewUpdateBrandImageGuardrailsOperationSchema,
] as const;

export const BRAND_IMAGE_GUARDRAILS_STORED_OPERATIONS =
  BRAND_IMAGE_GUARDRAILS_WIRE_OPERATIONS;
